import { Page, PageHeader } from "../components/ui";
import CreateUser from "../components/sidekick/users/CreateUser";

function AddUser() {
  return (
    <Page>
      <PageHeader
        back={{ to: "/admin/users", label: "Users" }}
        title="Add User"
      />
      <CreateUser />
    </Page>
  );
}

export default AddUser;
